export type ParsedStaticMapQuery = {
  lat?: number;
  lng?: number;
  zoom?: number;
  width?: number;
  height?: number;
  maptype?: "satellite" | "roadmap" | "hybrid" | "terrain";
  path: string[];
  markers: string[];
  hasOverlays: boolean;
  rawQuery: string;
};

function stripMapsKey(input: string): string {
  return input
    .replace(/https?:\/\/maps\.googleapis\.com\/maps\/api\/staticmap\??/i, "")
    .replace(/(&|\?)key=[^&]*/gi, "")
    .replace(/(&|\?)signature=[^&]*/gi, "")
    .replace(/^&/, "");
}

/** Parses a legacy Google Static Map query or full URL into structured params. */
export function parseStaticMapQuery(pathAndQuery: string): ParsedStaticMapQuery {
  const rawQuery = stripMapsKey(pathAndQuery).replace(/\s+/g, "");
  const params = new URLSearchParams(
    rawQuery.startsWith("?") ? rawQuery.slice(1) : rawQuery
  );

  const center = params.get("center") || "";
  const [latRaw, lngRaw] = center.split(",");
  const lat = latRaw !== undefined && latRaw !== "" ? Number(latRaw) : undefined;
  const lng = lngRaw !== undefined && lngRaw !== "" ? Number(lngRaw) : undefined;

  const size = params.get("size") || "";
  const [widthRaw, heightRaw] = size.split("x");
  const width =
    widthRaw !== undefined && widthRaw !== "" ? Number(widthRaw) : undefined;
  const height =
    heightRaw !== undefined && heightRaw !== "" ? Number(heightRaw) : undefined;

  const zoomRaw = params.get("zoom");
  const zoom = zoomRaw != null && zoomRaw !== "" ? Number(zoomRaw) : undefined;

  const maptypeRaw = params.get("maptype");
  const maptype =
    maptypeRaw === "satellite" ||
    maptypeRaw === "roadmap" ||
    maptypeRaw === "hybrid" ||
    maptypeRaw === "terrain"
      ? maptypeRaw
      : undefined;

  const path = params.getAll("path").filter(Boolean);
  const markers = params.getAll("markers").filter(Boolean);
  const hasOverlays = path.length > 0 || markers.length > 0;

  return {
    lat: Number.isFinite(lat) ? lat : undefined,
    lng: Number.isFinite(lng) ? lng : undefined,
    zoom: Number.isFinite(zoom) ? zoom : undefined,
    width: Number.isFinite(width) ? width : undefined,
    height: Number.isFinite(height) ? height : undefined,
    maptype,
    path,
    markers,
    hasOverlays,
    rawQuery,
  };
}

export function canUseMapsStaticBff(parsed: ParsedStaticMapQuery): boolean {
  return (
    parsed.lat !== undefined &&
    parsed.lng !== undefined &&
    Number.isFinite(parsed.lat) &&
    Number.isFinite(parsed.lng)
  );
}
